import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { RightSideDrawerPayload } from '../models';
import { TaxPeriod } from '../models/engagement/TaxPeriod';
import { LegalEntities } from '../models/legal-entity/legal-entity.model';
import { ManageClientUserDetails } from '../models/user-client/manage-clientuser-details';

@Injectable({
  providedIn: 'root'
})
export class RightSideDrawerService {
  // TODO: Delete all the properties specific to business functionality
  public rightSideDrawerControl = false;
  public loaderObsevable: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public singleRowEditData: any;
  public multipleRowAddData: any;
  public taxPeriods: TaxPeriod[];
  public legalEntities: LegalEntities[];
  public singleRowAddData: any;
  public isSendingBulkData: boolean;
  public smeListData: any;
  public surveyListData: any;
  // Used as a trigger to determine if input content on forms has to be refreshed. Inputs should be refreshed only on loading a form and resetting a form.
  public triggerRightSideDrawerClick = false;

  private drawerOpen$ = new BehaviorSubject<RightSideDrawerPayload>(new RightSideDrawerPayload());
  private drawerClosed$ = new BehaviorSubject<RightSideDrawerPayload>(new RightSideDrawerPayload());
  drawerOpen = this.drawerOpen$.asObservable();
  drawerClosed = this.drawerClosed$.asObservable();
  public triggerClickClose = false;

  public drawerName: string;
  isSearchKPMG: boolean;
  isFromCreateStudy = false;
  isFromEditStudy = false;

  notifyDrawerOpen(payload: RightSideDrawerPayload) {
    this.drawerOpen$.next(payload);
  }

  spinnerLoad(isLoading: boolean) {
    this.loaderObsevable.next(isLoading);
  }

  // clear content of drawer (inputs)
  public clearRightSideDrawerData = () => {
    this.singleRowEditData = {};
  };

  // Close Drawer function does not change content of right-side-drawer
  public closeRightSideDrawer = (data?: any) => {
   this.notifyDrawerOpen(new RightSideDrawerPayload());
    const payload = new RightSideDrawerPayload();
    payload.name = this.drawerName;
    payload.data = data;
    this.drawerClosed$.next(payload);
    this.rightSideDrawerControl = false;
    // Added to set the flag to default when drawer is closed
    this.spinnerLoad(false);
    this.setMandatoryField(false, '');
  };

  // Open Drawer function will change the content of the open drawer before showing right-side-drawer. If no variable is passed, it will not change the content.
  public openRightSideDrawer = (componentSelector: string, drawerTitle?: string, data?: any) => {
    const payload = new RightSideDrawerPayload();
    this.drawerName = drawerTitle;
    payload.name = componentSelector;
    payload.isOpen = true;
    payload.data = data;
    payload.drawerTitle = drawerTitle;
    this.triggerRightSideDrawerClick = true; // temporary trigger to determine first load of form
    this.rightSideDrawerControl = true; // trigger show and hide feature, controlled with CSS animation
    this.notifyDrawerOpen(payload);
  };

  // The Toggle Drawer function will detect if the drawer is opened or closed and will show\hide content. It will change the right-side-drawer content if a variable is passed and it is showing the drawer.
  public toggleRightSideDrawer = (componentSelector: string, drawerTitle?: string, data?: any) => {
    if (this.rightSideDrawerControl) {
      // If the drawer is open, close it.
      this.rightSideDrawerControl = false;
      this.notifyDrawerOpen(new RightSideDrawerPayload());
    } else {
      // If a variable for drawer content is passed through the function, load it.
      this.openRightSideDrawer(componentSelector, drawerTitle, data);
    }
  };

  // Re-initialise the drawer component
  public reInit = (selector: string, drawerTitle?: string, data?: any) => {
    if (this.rightSideDrawerControl) {
      this.rightSideDrawerControl = false;
      setTimeout(() => {
        this.openRightSideDrawer(selector, drawerTitle, data);
      });
    } else {
      this.openRightSideDrawer(selector, drawerTitle, data);
    }
  };
  // For setting the flag and drawer name for opening of closing the drawer on outside click
  public setMandatoryField(flag: boolean, drawerName) {
    if (flag) {
      this.triggerClickClose = true;
      this.drawerName = drawerName;
    } else {
      this.triggerClickClose = false;
    }
  }
  setIsSearchKPMG(isSearchKPMG: boolean) {
    this.isSearchKPMG = isSearchKPMG;
  }
  getIsSearchKPMG() {
    return this.isSearchKPMG;
  }
  setIsFromCreateStudy(isFromCreateStudy: boolean) {
    this.isFromCreateStudy = isFromCreateStudy;
  }
  getIsFromCreateStudy() {
    return this.isFromCreateStudy;
  }

  setIsFromEditStudy(isFromEditStudy: boolean) {
    this.isFromEditStudy = isFromEditStudy;
  }
  getIsFromEditStudy() {
    return this.isFromEditStudy;
  }
  manageClientUserDetails : ManageClientUserDetails;

  set manageClientUserData(data: ManageClientUserDetails){
    this.manageClientUserDetails = data;
  }

  get manageClientUserData() : ManageClientUserDetails{
    return this.manageClientUserDetails ;
  }

  
  private emailTipsModal = new BehaviorSubject<boolean>(false);
  emailTipsModal$ = this.emailTipsModal.asObservable();
  
  setEmailTipsModal(isModalOpen: boolean): void {
    this.emailTipsModal.next(isModalOpen);
}
}
